import { defineMessages } from 'react-intl-next';

export const commonMessages = defineMessages({
	learnMoreLink: {
		id: 'storage-enforcement.banner.learn-more',
		defaultMessage: 'Learn more',
		description:
			'Link text that users click on if they want to learn more about storage limits for each edition',
	},
});
